import {
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  TOKEN_CHECK,
  TOKEN_CHECK_FAIL,
  LOGIN_ALERT_REMOVE,
  LOGOUT,
  RESET_FAILED,
  RESET_SUCCESS,
  GET_USER_DATA_BY_EMAIL,
  SET_LOADING_FALSE,
  SET_LOGOUT_PROVISION,
  SET_AI_MODE,
  FIRST_TIMER,
  SET_URL_META_DATA,
  SET_DIV_TOGGLE,
  LOGIN_CALL_TOP_CARD,
  UPDATE_TOKEN,
  FILTER_DATA,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  isAuthenticated: false,
  loading: true,
  isError: false,
  isErrorType: null,
  errMessage: null,
  data: {},
  UserByEmail: {},
  setLogoutProvision: false,
  aimodeOn: sessionStorage.getItem("aiModeValue") === "true" ? true : false,
  firstTimer: false,
  urlMetaData: {},
  divToggle: true,
  loginCallTopCard: false,
  filterString: [],
  showFilter: false,
};

function authReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FILTER_DATA:
      return {
        ...state,
        filterString: payload.data,
        showFilter: payload.show,
      };
    case UPDATE_TOKEN:
      return {
        ...state,
        token: payload,
      };
    case LOGIN_CALL_TOP_CARD:
      return {
        ...state,
        loginCallTopCard: payload,
      };
    case SET_DIV_TOGGLE:
      return {
        ...state,
        divToggle: payload,
      };
    case SET_URL_META_DATA:
      return {
        ...state,
        urlMetaData: payload,
      };
    case FIRST_TIMER:
      return {
        ...state,
        firstTimer: payload,
      };
    case SET_AI_MODE:
      sessionStorage.setItem("aiModeValue", payload);
      return {
        ...state,
        aimodeOn: payload,
      };
    case TOKEN_CHECK:
      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        loading: false,
        data: {
          company_id: localStorage.company_id,
          email: localStorage.email,
          name: localStorage.name,
          role: localStorage.role,
        },
      };
    case SET_LOADING_FALSE:
      return {
        ...state,
        loading: false,
      };
    case LOGIN_SUCCESS:
      sessionStorage.setItem("token", payload.token);
      localStorage.setItem("token", payload.token);
      sessionStorage.setItem("company_id", payload.company_id);
      sessionStorage.setItem("email", payload.email);
      sessionStorage.setItem("name", payload.name);
      sessionStorage.setItem("role", payload.role);
      localStorage.setItem("company_id", payload.company_id);
      localStorage.setItem("email", payload.email);
      localStorage.setItem("name", payload.name);
      localStorage.setItem("role", payload.role);
      return {
        ...state,
        isAuthenticated: true,
        loading: true,
        token: payload.token,
      };
    case LOGIN_FAILED:
      sessionStorage.clear();
      localStorage.clear();
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        isError: true,
        isErrorType: "LOGIN_FAILED",
        errMessage: payload.message,
      };
    case SET_LOGOUT_PROVISION:
      return {
        ...state,
        setLogoutProvision: true,
      };
    case TOKEN_CHECK_FAIL:
    case LOGOUT:
    case LOGIN_ALERT_REMOVE:
      sessionStorage.clear();
      localStorage.clear();
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        isError: false,
        isErrorType: null,
        errMessage: null,
        data: {},
        setLogoutProvision: false,
      };
    case RESET_FAILED:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: true,
        isError: true,
        isErrorType: "RESET_FAILED",
        errMessage: payload.message,
      };
    case RESET_SUCCESS:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: true,
        isError: true,
        isErrorType: "RESET_SUCCESS",
        errMessage: payload.message,
      };
    case GET_USER_DATA_BY_EMAIL:
      return {
        ...state,
        UserByEmail: payload.data,
      };
    default:
      return state;
  }
}

export default authReducer;
